// src/components/coaches/CoachListTable.jsx
import React from "react";
import "./CoachListTable.css";
import CoachRow from "../CoachRow/CoachRow";

function CoachListTable({ coaches = [], onEdit, requestSort, sortConfig }) {
  return (
    <div className="coach-table-wrapper">
      <table className="coach-table">
        <thead className="coach-table-head">
          <tr>
            <th className="coach-table-head-checkbox">Id</th>
            <th
              onClick={() => requestSort("Name")}
              className="coach-table-head-cell coach-table-head-name"
            >
              {/* Name  {sortConfig.key === "Name" && (sortConfig.direction === "asc" ? "▲" : "▼")} */}
              <div className="th-flex">
                <span>İsim - Soyisim</span>
                {(function () {
                  var obj = sortConfig.find(function (s) {
                    return s.key === "Name";
                  });
                  if (obj && obj.direction === "asc")
                    return <span className="sort-arrow active">▲</span>;
                  if (obj && obj.direction === "desc")
                    return <span className="sort-arrow active">▼</span>;
                  return <span className="sort-arrow">⇅</span>; // neutral state
                })()}
              </div>
            </th>
            <th
              onClick={() => requestSort("Seats")}
              className="coach-table-head-cell"
            >
              {/* Seats {sortConfig.key === "Seats" && (sortConfig.direction === "asc" ? "▲" : "▼")} */}
              <div className="th-flex">
                <span>Kontenjan</span>
                {(function () {
                  var obj = sortConfig.find(function (s) {
                    return s.key === "Seats";
                  });
                  if (obj && obj.direction === "asc")
                    return <span className="sort-arrow active">▲</span>;
                  if (obj && obj.direction === "desc")
                    return <span className="sort-arrow active">▼</span>;
                  return <span className="sort-arrow">⇅</span>; // neutral state
                })()}
              </div>
            </th>

            <th className="coach-table-head-cell">Sıralama</th>
            <th
              onClick={() => requestSort("Status")}
              className="coach-table-head-cell"
            >
              {/* Status {sortConfig.key === "Status" && (sortConfig.direction === "asc" ? "▲" : "▼")} */}
              <div className="th-flex">
                <span>Durum</span>
                {(function () {
                  var obj = sortConfig.find(function (s) {
                    return s.key === "Status";
                  });
                  if (obj && obj.direction === "asc")
                    return <span className="sort-arrow active">▲</span>;
                  if (obj && obj.direction === "desc")
                    return <span className="sort-arrow active">▼</span>;
                  return <span className="sort-arrow">⇅</span>; // neutral state
                })()}
              </div>
            </th>
            <th className="coach-table-head-cell coach-table-head-actions">
              Düzenle
            </th>
          </tr>
        </thead>
        <tbody>
          {coaches.length === 0 ? (
            <tr>
              <td className="coach-table-empty" colSpan={7}>
                No coaches found.
              </td>
            </tr>
          ) : (
            coaches.map((coach) => (
              <CoachRow
                key={coach.Id}
                coach={coach}
                onEdit={(c) => onEdit(coach)}
              />
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}

export default CoachListTable;
